/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncMenuProductPage = lazyLoad(
  () => import('./index'),
  module => module.SyncMenuProductPage
);
